import { z } from "zod";
import { authenticatedFastApiAxiosInstance as http } from "@/lib/data/http";
import {
  skillSchema,
  skillSummarySchema,
  type SkillConfig,
  type SkillScope,
} from "@/lib/data/schemas/skills";
export async function listSkills(scope: SkillScope, cursor?: string) {
  return z
    .object({
      items: z.array(skillSummarySchema),
      nextCursor: z.string().nullable(),
    })
    .parse(
      (await http.get("skills", { params: { scope, cursor, limit: 30 } })).data,
    );
}
export async function getSkill(id: string) {
  return skillSchema.parse((await http.get(`skills/${id}`)).data);
}
export async function saveSkill(
  config: SkillConfig,
  id?: string,
  revision?: string,
) {
  const { scope, ...values } = config;
  return skillSchema.parse(
    (id
      ? await http.put(`skills/${id}`, { ...values, revision })
      : await http.post("skills", { scope, ...values })
    ).data,
  );
}
export async function deleteSkill(id: string, revision: string) {
  await http.delete(`skills/${id}`, { params: { revision } });
}

export async function listAvailableSkills(search: string, cursor?: string) {
  return z
    .object({
      items: z.array(skillSummarySchema.extend({ nativeName: z.string() })),
      nextCursor: z.string().nullable(),
    })
    .parse(
      (
        await http.get("skills/available", {
          params: { search, cursor, limit: 50 },
        })
      ).data,
    );
}
